var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var ListTypeIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 60,
    glyphHeight: 55,
    glyphOffsetY: -6
  }), React.createElement("path", {
    d: "M59.2174 29.826H17.4783V38.1739H59.2174V29.826Z"
  }), React.createElement("path", {
    d: "M9.13042 29.826H0.782593V38.1739H9.13042V29.826Z"
  }), React.createElement("path", {
    d: "M59.2174 46.5217H17.4783V54.8696H59.2174V46.5217Z"
  }), React.createElement("path", {
    d: "M9.13042 46.5217H0.782593V54.8696H9.13042V46.5217Z"
  }), React.createElement("path", {
    d: "M30 0.191284C23.1131 0.191284 17.4783 5.82607 17.4783 12.713C17.4783 19.6 23.1131 25.2348 30 25.2348C36.887 25.2348 42.5218 19.6 42.5218 12.713C42.5218 5.82607 37.0957 0.191284 30 0.191284ZM27.9131 18.9739L21.6522 12.713L23.7391 10.6261L27.9131 14.8L36.2609 6.45215L38.3478 8.53911L27.9131 18.9739Z"
  }));
};
export var ListTypeIconGlyph = function (props) {
  return React.createElement(ListTypeIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};